import React from "react";
import { makeStyles } from "@material-ui/core";
import { FileIcon } from "./FileIcon";

const useStyles = makeStyles(theme => ({
    root: {
        width: 100,
        height: 100,
        background: "#FFFFFF",
        border: "1px solid #CACCD1",
        boxSizing: "border-box",
        boxShadow:
            "0px 1px 1px rgba(0, 0, 0, 0.2), 0px 2px 1px rgba(0, 0, 0, 0.2)",
        borderRadius: "5px",
        //margin: `0 ${theme.spacing(2)}px ${theme.spacing(2)}px 0`,
        flexDirection: "column",
        padding: theme.spacing(1),
        position: "relative",
        fontSize: "10px",
        lineHeight: "16px"
    },
    row: {
        marginBottom: theme.spacing(1),
        display: "flex",
        justifyContent: "space-between"
    },
    icon: {
        width: 50,
        height: 50,
        marginBottom: theme.spacing(1)
    },
    fileMenu: {
        display: "flex",
        flexDirection: "column"
    },
    actionsMenu: {
        position: "absolute",
        top: 0,
        right: 0,
        height: 150,
        width: "60%",
        backgroundColor: "rgba(89, 110, 121, 0.8)",
        boxSizing: "border-box",
        borderBottomRightRadius: 5,
        borderTopRightRadius: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end"
    },
    actionIconButton: {
        margin: theme.spacing()
    },
    menu: {
        width: "100%"
    },
    menuItem: {
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        color: "#FFF",
        cursor: "pointer",
        fontSize: "12px"
    },
    fileName: {
        color: "#304967",
        'white-space': 'nowrap', /* Отменяем перенос текста */
        overflow: 'hidden', /* Обрезаем содержимое */
        'text-overflow': 'ellipsis', /* Многоточие */
     },
    fileSize: {
        color: "#BDBDBD"
    }
}));

function AttachmentCard(props) {
    const classes = useStyles();
    const { id, mimeType, fileName, fileSize } = props.fileInfo;
    return (
      <a href={props.link} download={fileName}>
        <div className={classes.root}>
          <div className={classes.icon}>
              <FileIcon mimeType={mimeType} />
          </div>
            <div className={classes.fileName}>{fileName}</div>
            <div className={classes.fileSize}>{fileSize}</div>
        </div>
      </a>
    );
}

export default AttachmentCard;
